"use client";
import { CosImage } from '@ssv-website/web-ui';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import { Image } from '@ssv-website/web-ui';
import { useEffect, useState } from 'react';
interface BgProps {
    bg: StaticImport | string;
    path?: string;
    children: React.ReactNode;
  }
  export const BgContainer = ({ bg, path, children }: BgProps) => {
    const [y, setY] = useState(0);
    const _bg = typeof bg === 'string' ? {
      backgroundImage: `url(${bg})`,
      backgroundSize: 'cover',
      backgroundPosition: `0 ${y}px`,
      backgroundRepeat: 'no-repeat',
    }:{};

    useEffect(() => {
        const handleResize = () => {
            const y = document.documentElement.clientWidth * (-210) /375;
          setY(y);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        }
    }, []);
    return (
      <div className="w-full h-fit relative" style={_bg}>
        {
          typeof bg !== 'string' && (path ? (
            <CosImage
              fallbackSrc={bg as any}
              path={path}
              className="w-full h-full absolute left-0 top-0 -z-10 object-fill"
              alt=""
            />
          ) : (
            <Image
              src={bg}
              className="w-full h-full absolute left-0 top-0 -z-10 object-fill"
              alt=""
            />
          ))
        }
        {children}
      </div>
    );
    
  }